import React from 'react';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Professional from './Professional';

export default function IntroHome() {
  // Reusable image sources (if needed)
  const mainImg =
    'https://images.pexels.com/photos/5740404/pexels-photo-5740404.jpeg';
  const secondaryImg =
    'https://images.pexels.com/photos/277253/pexels-photo-277253.jpeg';
  const aboutPattern = './Images/Home/about-pattern.svg';
  const headingIcon = './Images/Home/heading-icon.svg';

  return (
    <div className=" relative sm:mx-12 mx-4 mt-8">
      <div className="grid grid-cols-1 xl:grid-cols-2">
        {/* Left Section - Images */}
        <div className="relative mx-4">
          <img
            src={mainImg}
            alt="Main"
            className="md:w-[500px] w-[300px] rounded-xl absolute z-0"
          />
          <img
            src={aboutPattern}
            alt=""
            className="absolute right-0 md:block hidden"
          />
          <img
            src={secondaryImg}
            alt="Secondary"
            className="md:w-[400px] w-[200px] shadow-xl rounded-xl absolute float-right ml-[45%] md:mt-[20%] mt-[40%] z-10"
          />
          <div className="absolute bg-gray-600 py-6 px-4 rounded-xl mt-[60%] z-10 lg:ml-28 md:ml-24 flex justify-between md:flex-row flex-col gap-4">
            <p className="lg:text-6xl text-4xl text-center font-bold text-green-500 bg-transparent">
              100%
            </p>
            <div className="opacity-60 bg-transparent">
              <p className="text-xl font-semibold text-white bg-transparent">Customer</p>
              <p className="text-xl font-semibold text-white bg-transparent">Satisfaction</p>
            </div>
          </div>
        </div>

        {/* Right Section - Content */}
        <div className="relative lg:float-right lg:ml-[15%]  xl:mt-12 lg:mt-[65%] sm:mt-[85%] mt-[115%] ">
          <p className="text-2xl font-semibold uppercase text-green-500 py-4">
           Who are WE?
          </p>
          <img
            src={headingIcon}
            alt=""
            className="absolute float-right lg:right-36 right-12 top-8"
          />
          <h3 className="text-5xl font-semibold leading-tight md:w-[80%] w-full">
            Leading the Spice Trade Revolution
          </h3>
          <p className="text-lg py-6 opacity-60">
            Arundhati Exim delivers premium spices globally, ensuring quality,
            authenticity, sustainability, and ethical sourcing while supporting
            traditional farming communities.
          </p>
          <h2 className="text-2xl text-green-400 font-semibold">
            We’re in this business Since 2012 and we provide the best services
          </h2>
          <ul className="opacity-50 mt-4 flex flex-col gap-2">
            <li>Premium Quality Spices</li>
            <li>Fresh Flavors, Global Reach</li>
          </ul>
          <div className="mt-3">
            <div className="float-left">
              <AvatarGroup spacing={4}>
                <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" />
                <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />
                <Avatar alt="Aindy Baker" src="/static/images/avatar/3.jpg" />
                <Avatar alt="Sindy Baker" src="/static/images/avatar/3.jpg" />
              </AvatarGroup>
              <p className="text-black">Our 1020+ clients</p>
            </div>
          </div>
        </div>
        
      </div>
      <div className='mt-24'> <Professional/> </div>
    </div>
  );
}
